var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Read',{attrs:{"id":+_vm.$route.params.id,"back-link":_vm.$currentModule.getRoute('all-articles')}})}
var staticRenderFns = []

export { render, staticRenderFns }